import React from "react";
import { IconDiv } from "~/src/components/payroll/style";
import IconLink from "~/src/containers/payroll/components/IconLink";
import {
  formatDateMonthTimeShort,
  formatHoursMinutes,
} from "~/src/utils/formatting";
import Icon from "~/src/components/icon";

import { getFillText, getStateColor } from "../../utils";
import { ModalTable } from "./styles";
import { COLORS } from "~/src/styles/config.style";

/**
 * Stream info panel for carousel. Shows stream details and status, with color coding.
 */
export const StreamPanel: React.FC<{
  stream: any;
  showMenu: boolean;
  onClick: () => void;
}> = ({ stream, showMenu, onClick }) => {
  const isStarted = stream.state === "STARTED";
  const isMissed = stream.state === "MISSED";
  const isCancelled = stream.state === "CANCELLED";
  const isGone = stream.state === "GONE";

  const color = getStateColor(stream);

  return (
    <ModalTable key={stream.id} color={color}>
      <tbody>
        <tr>
          <td style={{ width: "5vw" }}>
            <a href="#" onClick={onClick}>
              #{stream.id}
            </a>

            {isStarted && <div>started</div>}
            {isMissed && <div>missed</div>}
            {isCancelled && <div>cancelled</div>}
            {isGone && <div>gone</div>}
          </td>
          <td style={{ textAlign: "left" }}>
            {stream.shift.sourceAccount.accountName}
            <br />
            {stream.shift.venue.name}
            <br />
            {stream.shift.role.name}
            <br />
            {formatDateMonthTimeShort(stream.shift.startTime)} -{" "}
            {formatHoursMinutes(stream.shift.endTime)}
          </td>
          <td style={{ width: "6vw" }}>{getFillText(stream)}</td>
          {showMenu && (
            <td style={{ width: "4vw" }}>
              <IconDiv>
                <IconLink
                  name="MORE"
                  size={25}
                  isButton
                  color={Icon.colors.MAIN_ORANGE}
                  tooltip="Actions"
                  onClick={onClick}
                />
              </IconDiv>
            </td>
          )}
        </tr>
      </tbody>
    </ModalTable>
  );
};

export const ReasonPanel: React.FC<{ reason: string; showMenu: boolean }> = ({
  reason,
  showMenu,
}) => {
  return (
    <ModalTable key={reason} color={COLORS.RED}>
      <tbody>
        <tr>
          <td style={{ width: "5vw" }}>⚠️</td>
          <td style={{ textAlign: "left" }}>{reason}</td>
          <td style={{ width: "6vw" }}>&nbsp;</td>
          {showMenu && <td style={{ width: "4vw" }}>&nbsp;</td>}
        </tr>
      </tbody>
    </ModalTable>
  );
};
